export interface UserToken {
	// note: incomplete interface
	id: string;
	properties: {
		token: string;
		token_type: string;
		confirmed: boolean;
		is_default: boolean;
	};

	resetVerificationStatus: RequestStatus;
	deleteStatus: EphemeralRequestStatus;
}

interface UserTokensState {
	fetchStatus: RequestStatus;
	post: {
		status: RequestStatus;
		error: {
			message: string;
		};
	};
	delete: {
		// note: `status` is stored for each individual token
		error: {
			message: string;
		};
	};
	all: UserToken[];
}

const INITIAL_USER_TOKENS_STATE: UserTokensState = {
	fetchStatus: "",
	post: {
		status: "",
		error: {
			message: "",
		},
	},
	delete: {
		error: {
			message: "",
		},
	},
	all: [],
};

export default (
	state: UserTokensState = INITIAL_USER_TOKENS_STATE,
	action: any
): UserTokensState => {
	switch (action.type) {
		case "CURRENT_USER/LOGGED_OUT": {
			return { ...INITIAL_USER_TOKENS_STATE };
		}

		case "USER_TOKENS/GET_TOKENS/PENDING": {
			return {
				...state,
				fetchStatus: "pending",
			};
		}

		case "USER_TOKENS/GET_TOKENS/SUCCESS": {
			return {
				...state,
				fetchStatus: "success",
				all: action.data.tokens.map(
					(t: UserToken): UserToken => ({
						...t,
						resetVerificationStatus: "",
					})
				),
			};
		}

		case "USER_TOKENS/GET_TOKENS/FAILURE": {
			// todo: error message
			return {
				...state,
				fetchStatus: "failure",
			};
		}

		case "USER_TOKENS/ADD_TOKEN/PENDING": {
			return {
				...state,
				post: {
					...state.post,
					status: "pending",
					error: {
						message: "",
					},
				},
			};
		}

		case "USER_TOKENS/ADD_TOKEN/SUCCESS": {
			return {
				...state,
				all: [...state.all, action.data.token],
				post: {
					...state.post,
					status: "success",
					error: {
						message: "",
					},
				},
			};
		}

		case "USER_TOKENS/ADD_TOKEN/FAILURE": {
			return {
				...state,
				post: {
					...state.post,
					status: "failure",
					error: {
						message: action.data.error.message,
					},
				},
			};
		}

		case "USER_TOKENS/DELETE_TOKEN/PENDING": {
			return {
				...state,
				all: state.all.map(
					(t: UserToken): UserToken =>
						t.id !== action.data.tokenId
							? t
							: {
									...t,
									deleteStatus: "pending" as EphemeralRequestStatus,
							  }
				),
			};
		}

		case "USER_TOKENS/DELETE_TOKEN/SUCCESS": {
			return {
				...state,
				all: state.all.filter(token => token.id !== action.data.tokenId),
			};
		}

		case "USER_TOKENS/DELETE_TOKEN/FAILURE": {
			return {
				...state,
				all: state.all.map(
					(t: UserToken): UserToken =>
						t.id !== action.data.tokenId
							? t
							: {
									...t,
									deleteStatus: "failure" as EphemeralRequestStatus,
							  }
				),
				delete: {
					...state.delete,
					error: {
						...state.delete.error,
						message: action.data.error.message,
					},
				},
			};
		}

		case "USER_TOKENS/RESET_TOKEN_VERIFICATION/PENDING": {
			return {
				...state,
				all: state.all.map(
					t =>
						t.properties.token !== action.data.token
							? t
							: {
									...t,
									resetVerificationStatus: "pending" as RequestStatus,
							  }
				),
			};
		}

		case "USER_TOKENS/RESET_TOKEN_VERIFICATION/SUCCESS": {
			return {
				...state,
				all: state.all.map(
					t =>
						t.properties.token !== action.data.token
							? t
							: {
									...t,
									resetVerificationStatus: "success" as RequestStatus,
							  }
				),
			};
		}

		case "USER_TOKENS/RESET_TOKEN_VERIFICATION/FAILURE": {
			// todo: error message and ui

			return {
				...state,
				all: state.all.map(
					t =>
						t.properties.token !== action.data.token
							? t
							: {
									...t,
									resetVerificationStatus: "failure" as RequestStatus,
							  }
				),
			};
		}
	}

	return state;
};

// helper to get this reducer's state as a typed value
const userTokensState = state => state.userTokens as UserTokensState;

export const selectors = {
	selectUserTokens: state => userTokensState(state).all,
	selectUserTokensFetchStatus: state => userTokensState(state).fetchStatus,
	selectUserTokensPostStatus: state => userTokensState(state).post.status,
	selectAddUserTokenError: state => userTokensState(state).post.error,
	selectDeleteUserTokenError: state => userTokensState(state).delete.error,
};
